// Remote client-side logging is intentionally disabled. Authentication data,
// member data and webhook credentials must never be stored or transmitted by
// a browser logging helper. Preserve the public API until callers are migrated.
const writeLog = () => undefined;
const logDiscord = () => undefined;

export { logDiscord, writeLog };
